import request from '@/utils/request'

export function save(description) {
    return request({
      url: 'cost-center/save',
      method: 'post',
      data: { description }
    });
  }
  
  export function update(id,description) {
    return request({
      url: 'cost-center/update',
      method: 'put',
      data: { id, description }
    });
  }
  
  export function getAll() {
    return request({
      url: 'cost-center/getAll',
      method: 'get',
    });
  }
  
  export function edit(id) {
    return request({
      url: 'cost-center/edit/'+id,
      method: 'get',
    });
  }
  
  export function destroy(id) {
    return request({
      url: 'cost-center/destroy/' + id,
      method: 'delete',
    });
  }